import { Sidecar } from '@eppendorf/vnls-react-components';
import { type ReactElement, useState } from 'react';
import { useRouteError, useSearchParams } from 'react-router-dom';

import { LoadingErrorHint } from '$components/loading-error-hint/loading-error-hint';
import { SidecarRouterOutlet } from '$components/sidecar-router/sidecar-router-outlet';
import { useAuditEventDetailQuery } from '$features/audit-events/audit-events.api';
import { AuditEventDetailHeader } from '$features/audit-events/detail/audit-event-detail-header';

export function AuditEventDetailSidecar(): ReactElement {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSidecarOpen, setIsSidecarOpen] = useState(true);
  const routeError = useRouteError();
  const { isError, data } = useAuditEventDetailQuery(searchParams.get('id') || '');

  const handleSidecarOpenChange = () => {
    setIsSidecarOpen(false);
    // here we ensure that we the latest search params doesn't get reset.
    setSearchParams(
      (prev) => {
        prev.delete('sidecarRoute');
        prev.delete('id');
        return prev;
      },
      { replace: true },
    );
  };

  return (
    <Sidecar isOpen={isSidecarOpen} onOpenChange={handleSidecarOpenChange}>
      {(routeError || isError || !data) && <LoadingErrorHint className="m-top-xl" />}

      {data && (
        <div className="flex flex__dir--column flex__ai--stretch h-full">
          <AuditEventDetailHeader
            activityName={data?.activityCodeDescription}
            activityCode={data?.activityCode}
          />
          <div className="sidecar__details box box-remove-padding">
            <div className="sidecar__outlet-wrapper">
              <SidecarRouterOutlet />
            </div>
          </div>
        </div>
      )}
    </Sidecar>
  );
}
